export interface TemplateNavigation {
    label?: string;
    slug?: string;
    target?: TemplateNavigation.TargetEnum;
    path?: string;
  }
  export namespace TemplateNavigation {
    export type TargetEnum =
      | "PLP"
      | "PDP"
      | "INTERNAL_PAGE"
      | "EXTERNAL_PAGE"
      | "PROMOS";
    export const TargetEnum = {
      PLP: "PLP" as TargetEnum,
      PDP: "PDP" as TargetEnum,
      INTERNALPAGE: "INTERNAL_PAGE" as TargetEnum,
      EXTERNALPAGE: "EXTERNAL_PAGE" as TargetEnum,
      PROMOS: "PROMOS" as TargetEnum,
    };
  }
  